"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioButtonLabel = exports.RadioButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
var RadioButtonLabel = exports.RadioButtonLabel = _styledComponents["default"].label(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  align-self: center;\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 1px solid #bebebe;\n"])));
var RadioButton = exports.RadioButton = _styledComponents["default"].input(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  opacity: 0;\n  z-index: 1;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n\n  &:checked + ", " {\n    background: white;\n    border: 1px solid #eeeeee;\n\n    &::after {\n      content: \"\";\n      display: block;\n      border-radius: 50%;\n      width: 10px;\n      height: 10px;\n      margin: 7px;\n      background: #0b7074;\n    }\n  }\n"])), RadioButtonLabel);
var RadioButtonComponent = function RadioButtonComponent(_ref) {
  var value = _ref.value,
    checked = _ref.checked;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(RadioButton, {
    type: "radio",
    value: value,
    checked: checked,
    readOnly: true
  }), _react["default"].createElement(RadioButtonLabel, null));
};
var _default = exports["default"] = RadioButtonComponent;